export const SWITCH_TECHNICAL_CARD_TAB = 'SWITCH_TECHNICAL_CARD_TAB';
export const TECHNICAL_CARD_UPLOAD_SUCCESS = 'TECHNICAL_CARD_UPLOAD_SUCCESS';
export const CAR_DATA_FORM_VALUES_SUCCESS = 'CAR_DATA_FORM_VALUES_SUCCESS';
export const STORE_CAR_DATA_FORM_VALUES_SUCCESS = 'STORE_CAR_DATA_FORM_VALUES_SUCCESS';
export const STORE_CAR_DATA_FORM_VALUES = 'STORE_CAR_DATA_FORM_VALUES';
export const CLEAR_CAR_DATA_STORE = 'CLEAR_CAR_DATA_STORE';
export const STOP_LOADING_CAR_DATA = 'STOP_LOADING_CAR_DATA';
export const SET_CLIENT_CAR_PLATE = 'SET_CLIENT_CAR_PLATE';


// WEBPACK FOOTER //
// ./src/workflow/checkout/carData/types.js